<form
  (ngSubmit)="onSubmit()"
  #payerFlowForm="ngForm"
  class="editForm"
  novalidate
  style="margin-bottom: 1rem"
>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label>*Episode Type</label>
        <app-select
          id="episodeType"
          name="episodeType"
          #episodeTypesList
          [items]="episodeTypes"
          [multiple]="true"
          [allowClear]="true"
          [selected]="refreshEpisodeTypes"
          placeholder="Select an Episode Type"
        ></app-select>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label class="control-label">*Payer</label>
        <app-select
          id="payer"
          name="payer"
          #payersList
          [items]="payers"
          [selected]="selectPayer"
          placeholder="Select a Payer"
        >
        </app-select>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label class="control-label">*Plan</label>
        <app-select
          id="plan"
          name="plan"
          #plansList
          [items]="payerPlans"
          [multiple]="true"
          [allowClear]="true"
          [selected]="refreshPlans"
          [placeholder]="planPlaceholder"
          [disabled]="payerPlans.length === 0"
        ></app-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label class="control-label">*Start Date</label>
        <app-datetime
          id="startDate"
          name="startDate"
          (dateChange)="onStartDateChange($event)"
          [(ngModel)]="startDateVal"
          [options]="util.getDefaultDateOptions(false, false, true, false, true)"
          #startDate
        ></app-datetime>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label class="control-label">End Date</label>
        <app-datetime
          id="endDate"
          name="endDate"
          (dateChange)="onEndDateChange($event)"
          [(ngModel)]="endDateVal"
          [options]="util.getDefaultDateOptions(false, false, true, false, true)"
          #endDate
        ></app-datetime>
      </div>
    </div>
  </div>

  <div class="row">
    <button class="btn btn-default pull-right" style="margin-right: 15px" (click)="cancelEdit()">
      Cancel
    </button>
    <button type="submit" class="btn btn-success pull-right" style="margin-right: 15px">
      Save
    </button>
  </div>
</form>
